<template>
    <div class="ads-container">
        <div class="ads-title">Advertisement</div>
        <ins class="adsbygoogle"
  style="display:block"
  data-ad-client="ca-pub-8605814769064371"
  :data-ad-slot="adSlot"
  :data-ad-channel="adChannel"
  data-ad-format="auto"
  data-full-width-responsive="true"></ins>
    </div>
</template>

<script>
    const adChannel = new URLSearchParams(window.location.search).get("cid");
    export default {
        name: "Ads",
        props: {
            adSlot: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                adChannel,
            };
        },
        mounted() {
            this.loadAds();
        },
        methods: {
            loadAds() {
                window.adsbygoogle.push({});
            },
        },
    };
</script>

<style lang="less" scoped>
    .ads-title {
        height: 9px;
        background: rgba(219, 219, 219, 1);
        font-size: 8px;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 9px;
        text-align: center;
    }

    ins {
        background: rgba(235, 235, 235, 1);
    }
</style>